import React from 'react';
import { checkAdminRole, checkAPIUser} from 'src/store/common';
import { useStoreContext } from 'src/store/context';
import { ApiGenAuth } from './ApiGenAuth';
import { ApiGenNotAuth } from './ApiGenNotAuth';

export const ApiGen: React.FC = () =>{
  const [state] = useStoreContext();

  return(
      <div>
        {
            state.user && (checkAdminRole(state.user) || checkAPIUser(state.user)) ?
            (<ApiGenAuth/>):
            (<ApiGenNotAuth/>)
        }
      </div>
  )
}